import { render } from "./ViewDiscrepancy.vue?vue&type=template&id=e655d604"
import script from "./ViewDiscrepancy.vue?vue&type=script&lang=js"
export * from "./ViewDiscrepancy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__